export const TASK = {
  WORKER_VERSION: 'work-v022-1',
  WORKER_HANDSHAKE_TIMEOUT: 10000,
  HASH_BATCH_SIZE: 4096,
  MAX_BLOCKS_WHEN_ESTIMATING: 30000,
  MAX_CONCURRENT_PROCESSES: 5,
  CHECKPOINT_COMMIT: 5000000,
  DIFFICULTY_RECALCULATE: 5000000,
  DIFFICULTY_START: 10,
  DIFFICULTY_START_SLEEP_DELAY: 10000,
  CHECKPOINT_BLOCK: 10,
  ESTIMATED_BLOCK_TIME: 6000,
  REFINE_WORK_LOOKUP_BLOCKS: 5,
  HASHRATE_INITIAL_ESTIMATE: 300.0,
  IDENTITY_PREFIX: "IDENTITY",
  NONCE_PREFIX: "NONCE",
  TARGET_DELIMITER: "@",
  AUTOMATIC_STATUS_INTERVAL: 60000,
  START_DELAY: 8000,
};
